export var QuotationActionTypes;
(function (QuotationActionTypes) {
    QuotationActionTypes["QUOTATION_ATTEMPT"] = "QUOTATION_ATTEMPT";
    QuotationActionTypes["QUOTATION_SUCCESS"] = "QUOTATION_SUCCESS";
    QuotationActionTypes["QUOTATION_FAILURE"] = "QUOTATION_FAILURE";
})(QuotationActionTypes || (QuotationActionTypes = {}));
